/**
 * @copyright © Paramount Streaming
 * @description Media-type values produced by TN Web's ContentCANVideo GraphQL type,
 * supplied via paramsVO.STITCHER.items[0].mediaType (VOD) and
 * paramsVO.STITCHER.channels[0].currentListing[0].contentCANVideo.mediaType (live).
 * Distinct from MPXMediaType which sources from the MPX CMS. Values defined here
 * are the subset currently consumed by PTVResponseBuilder; extend as needed.
 */
export enum ContentCANVideoMediaType {
	CLIP = 'Clip',
	TRAILER = 'Trailer',
	MOVIE = 'Movie'
}